module.exports = __webpack_public_path__ + "assets/icons/tag-multiple-2c68.svg";